export default {"src":"/_next/static/media/lever-logo-standard.6b716014.svg","height":48,"width":48};